"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scigliano": {
    "2cccb9ed": [{
      "hkey": "3b2d3375",
      "slug": "scigliano",
      "name": "Scigliano",
      "primary": true,
      "skipSearch": false
    }],
    "agriforglio": [{
      "hkey": "3b2d3375",
      "slug": "scigliano",
      "name": "Scigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cf3c8320": [{
      "hkey": "3b2d3375",
      "slug": "scigliano",
      "name": "Scigliano",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "3b2d3375",
      "slug": "scigliano",
      "name": "Scigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "777e2823": [{
      "hkey": "3b2d3375",
      "slug": "scigliano",
      "name": "Scigliano",
      "primary": true,
      "skipSearch": false
    }],
    "sant-agostino": [{
      "hkey": "3b2d3375",
      "slug": "scigliano",
      "name": "Scigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae9054e6": [{
      "hkey": "3b2d3375",
      "slug": "scigliano",
      "name": "Scigliano",
      "primary": true,
      "skipSearch": false
    }],
    "vallescura": [{
      "hkey": "3b2d3375",
      "slug": "scigliano",
      "name": "Scigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;